import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { FormActivityPickupService } from './form-activity-pickup.service';
import { Step1Component } from './step1/step1.component';
import { Step2Component } from './step2/step2.component';
import { RouterService } from '@services/router.service';

@Component({
  selector: 'app-form-activity-pickup',
  templateUrl: './form-activity-pickup.component.html',
  styleUrls: ['./form-activity-pickup.component.scss'],
  providers: [FormActivityPickupService],
  standalone: false,
})
export class FormActivityPickupComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private formActivityPickupService = inject(FormActivityPickupService);
  private routerService = inject(RouterService);

  @ViewChild(Step1Component) step1Component: Step1Component;
  @ViewChild(Step2Component) step2Component: Step2Component;

  ngOnInit() {
    this.routerService.disableSetPreviousHref();
    this.router.navigate(['.'], { queryParams: { step: 1 }, queryParamsHandling: 'merge', relativeTo: this.route, replaceUrl: true });
    this.route.queryParams.subscribe((params) => {
      const step = +params['step'] || 1;
      if (this.formActivityPickupService.currentStep === 2 && step === 1) {
        this.formActivityPickupService.setStep1State();
      }
    });
  }

  get isStep2(): boolean {
    return this.formActivityPickupService.currentStep === 2;
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.step1Component) {
      return this.step1Component.canDeactivate();
    } else {
      return this.step2Component.canDeactivate();
    }
  }
}
